// icon path => scale value
export const iconScale: Record<string, string> = {
    '~icons/mdi/dog.svelte': '1.4',
    '~icons/game-icons/bear-face.svelte': '1.2',
    '~icons/game-icons/crowned-skull.svelte': '1.2',
};
